import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initPhilosophyStory(): void {
    const sections = document.querySelectorAll<HTMLElement>('.garden-section, .story-section');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isInInitialViewport = (element: HTMLElement): boolean => {
        const rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight * 0.92 && rect.bottom > window.innerHeight * 0.08;
    };

    const gardenPath = document.querySelector<SVGPathElement>('[data-garden-path]');
    if (gardenPath && !reduceMotion) {
        const pathLength = gardenPath.getTotalLength();
        gardenPath.style.strokeDasharray = `${pathLength}`;
        gardenPath.style.strokeDashoffset = `${pathLength}`;

        gsap.to(gardenPath, {
            strokeDashoffset: 0,
            ease: 'none',
            scrollTrigger: {
                trigger: '#phil-story',
                start: 'top 70%',
                end: 'bottom 70%',
                scrub: true
            }
        });
    }

    sections.forEach((section, index) => {
        const copy = section.querySelector('.garden-copy, .story-copy');
        const visual = section.querySelector('.garden-symbol, .garden-visual, .story-visual');
        const isReverse = section.querySelector('.story-grid--reverse') !== null || index % 2 === 1;

        if (reduceMotion) {
            copy?.classList.add('is-visible');
            visual?.classList.add('is-visible');
            return;
        }

        if (isInInitialViewport(section)) {
            if (copy) gsap.set(copy, { opacity: 1, x: 0, y: 0 });
            if (visual) gsap.set(visual, { opacity: 1, scale: 1, y: 0 });
            return;
        }

        if (copy) {
            gsap.fromTo(copy,
                { opacity: 0, x: isReverse ? 40 : -40 },
                {
                    opacity: 1, x: 0,
                    duration: 1,
                    ease: 'power3.out',
                    immediateRender: false,
                    scrollTrigger: {
                        trigger: section,
                        start: 'top 88%',
                        toggleActions: 'play none none none',
                        once: true
                    }
                }
            );
        }

        if (visual) {
            gsap.fromTo(visual,
                { opacity: 0, scale: 0.88, y: 24 },
                {
                    opacity: 1, scale: 1, y: 0,
                    duration: 1.2,
                    ease: 'expo.out',
                    immediateRender: false,
                    scrollTrigger: {
                        trigger: section,
                        start: 'top 88%',
                        toggleActions: 'play none none none',
                        once: true
                    }
                }
            );
        }
    });

    if (document.querySelector('#phil-enso')) {
        gsap.to('#phil-enso', {
            scale: 1.45,
            opacity: 0.08,
            scrollTrigger: {
                trigger: '.phil-hero',
                start: 'top top',
                end: 'bottom top',
                scrub: true
            }
        });
    }
}

export function initCultureDojo(): void {
    const visual = document.querySelector('.dojo-hero-visual');
    if (!visual) return;

    gsap.fromTo(visual,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1.5, ease: 'power3.out' }
    );

    // SVG elements animate via CSS keyframes - no further JS needed
}

export function initCompanySynthesis(): void {
    const synthesis = document.getElementById('comp-synthesis');
    if (!synthesis) return;

    // Fade in the IKIGAI visual on load
    gsap.fromTo(synthesis,
        { opacity: 0, scale: 0.94 },
        { opacity: 1, scale: 1, duration: 1.4, ease: 'power3.out', delay: 0.2 }
    );
}
